import Http from "../util/Http";

class CommentApi {

    static async getComments(postId) {
        const res = await Http.get(`/comment/${postId}`);
        return res || null;
    }

    static async createComment(commentPostId, commentParentId, commentContent, userNicknm) {
        const res = await Http.post('/comment', {
            commentPostId,
            commentParentId,
            commentContent,
            userNicknm
        });
        return res || null;
    }

    static async deleteComment(commentId) {
        const res = await Http.delete(`/comment/${commentId}`)
        return res || null;
    }
    
    static async likeComment(commentId) {
        const res = await Http.post(`/comment/${commentId}/like`);
        return res || null;
    }
}

export default CommentApi